import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Context } from '../context/Context'
import { backgrounds } from "../Database/Database"
import PopupModal from "./PopupModal";
import axios from "axios";
import { getHeaders, body, base } from "../Config";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { SendGuiDataEvents } from "../lib/CommonScript";

export default function Backgrounds() {

    const { lang ,theme} = useContext(Context);
    const [showModal, setShowModal] = useState(false);
    const [imgUrl, setImgUrl] = useState("");
    const [wallpapers, setWallpapers] = useState([]);

    // useEffect(() => {
    //     axios({
    //         method : "post",
    //         url : base + "wallpaper",
    //         data: body["wallpaper"],
    //         headers: getHeaders(),
    //     })
    //     .then((resp) => {
    //         console.log("resp --->",resp)
    //         setWallpapers(resp.data.wallpapers)
    //     })
    //     .catch((error) => {
    //         console.log("error --->",error)
    //     })
    // },[])

    useEffect(() => {
        //send gui events
        let guiDataEvent = {};
        guiDataEvent["w_action"] = "card_click";
        guiDataEvent["name"] = "wallpaper";
        SendGuiDataEvents(guiDataEvent);
      }, []);





    return (
        <div className={`w-full z-10 ${theme === "red" ? "bg-red_bg_pic  bg-center" : "bg-green_bg_pic bg-cover bg-center bg-no-repeat"} pt-20 max-width`}>
            {showModal &&
                <div className="z-30 fixed h-70v left-2 right-2 top-20 bottom-20">
                    < PopupModal showModal={showModal} setShowModal={setShowModal} imgUrl={imgUrl} />
                </div>
            }
            <div className="grid grid-cols-2 gap-8 px-4 pb-4 ">
                {
                    backgrounds && backgrounds.map((data, index) => {
                        return (
                            <div key={index} className=" mx-auto border-2 "
                                onClick={() => {
                                    console.log(" img clicked --->")
                                    setImgUrl(require("../assets/green/gallery/" + data));
                                    setShowModal(true);
                                }}
                            >
                                <img src ={require("../assets/green/gallery/"+data)} style={{width: "14rem", height: "15rem"}} loading="lazy" />


                                {/* <LazyLoadImage src={require("../assets/green/gallery/"+data)}
                                    width={145} height={212}
                                    effect="blur"
                                    className="z-10"
                                /> */}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}